<template>
    <div class="flex items-center justify-center">
        <div v-if="sold_out" class="flex items-center justify-center bg-red-500 text-white border px-2 py-1 border-red-500 rounded-full text-xs">
            {{ $t('Sold out') }}!
        </div>
        <div v-else class="dark:text-primary gap-2 flex items-center justify-center">
            <span v-if="checkingStatus == 'checking'" class="flex items-center justify-center text-white border pl-1 pr-2 py-1 border-white rounded-full">
                <div class="inline-block h-4 w-4 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                    role="status">
                    <span
                        class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                </div>
                <span class="ml-2 text-xs">{{ $t("checking availability") }}</span>
            </span>
            <span v-else-if="checkingStatus == 'done'" class="flex items-center justify-center bg-primary dark:bg-transparent text-white border px-2 py-1 border-primary dark:border-white rounded-full text-xs">{{ $t('Tickets available') }}!</span>
            <span v-else class="flex items-center justify-center bg-primary dark:bg-transparent text-white border px-2 py-1 border-primary dark:border-white rounded-full text-xs">{{ $t('Cannot find tickets') }}!</span>

        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            sold_out: this.$attrs.sold_out ?? false,
            checkingStatus: 'checking',
            url: this.$attrs.url ?? '',
        }
    },
    mounted() {
        this.checkAvailable();
    },
    methods: {
        async checkAvailable() {
            this.checkingStatus = 'checking';
            var url = this.url;
            var _this = this;

            axios({
                method: 'get',
                url: url,
            }).then(function (response) {
                _this.checkingStatus = 'done';
            })
            .catch(function (error) {
                _this.checkingStatus = 'error';
                console.log(error);
            });
        },
    }
};
</script>
  